import { Component, type ErrorInfo, type ReactNode } from "react";

import { ErrorScreen } from "./ErrorScreen";

interface State {
  error: unknown;
}

/** Last line of defence: a crash in any page shows a recoverable screen instead of a blank tab. */
export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { error: undefined };

  static getDerivedStateFromError(error: unknown): State {
    return { error };
  }

  override componentDidCatch(error: unknown, info: ErrorInfo): void {
    console.error("Orthos crashed", error, info.componentStack);
  }

  override render(): ReactNode {
    if (this.state.error === undefined) return this.props.children;
    return (
      <ErrorScreen
        title="Something went wrong"
        detail={
          this.state.error instanceof Error ? this.state.error.message : String(this.state.error)
        }
        onRetry={() => {
          this.setState({ error: undefined });
        }}
      />
    );
  }
}
